var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"wrap"},[_c('div',{staticClass:"row justify-content-center"},[_c('div',{staticClass:"col-12 content"},[_c('Twitch')],1)])])}
var staticRenderFns = []

export { render, staticRenderFns }